module.exports = __webpack_public_path__ + "img/fire-station.14517379.webp";